<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_search_placeholder_chooseEvgSpu') ||
                  'SPU编号/SPU名称/客户名称/品牌名称/产品系列/产品品类 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" label-width="90px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_evgSpuNo') || 'SPU编号'"
            >
              <el-input
                v-model.trim="form.evgSpuNo"
                :placeholder="
                  $l('form_choose_search_placeholder_evgSpuNo') ||
                    '请输入SPU编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_goodsName') || 'SPU名称'"
            >
              <el-input
                v-model.trim="form.goodsName"
                :placeholder="
                  $l('form_choose_search_placeholder_goodsName') ||
                    '请输入SPU名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_customer') || '产品客户'"
            >
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('form_choose_search_placeholder_customer') ||
                    '请选择产品客户'
                "
                filterable
                multiple
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_brand') || '产品品牌'"
            >
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('form_choose_search_placeholder_brand') || '请选择产品品牌'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_category') || '产品分类'"
            >
              <el-cascader
                v-model="form.categoryCode"
                :options="categoryTree"
                :props="{
                  emitPath: false,
                  checkStrictly: false,
                  value: 'value',
                  label: 'label',
                }"
                filterable
                clearable
                style="width: 100%"
                :showAllLevels="false"
                :placeholder="
                  $l('form_choose_search_placeholder_category') ||
                    '请选择产品分类'
                "
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_collection') || '产品系列'"
            >
              <dict-select
                v-model="form.listCollectionNo"
                url="/master/common/dict/biz"
                :body="{ dictType: 'skuCollection' }"
                :placeholder="
                  $l('form_choose_search_placeholder_collection') ||
                    '请选择产品系列'
                "
                clearable
                filterable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_design') || '企划人员'"
            >
              <dict-select
                v-model="form.listDesignCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_choose_search_placeholder_design') ||
                    '请选择企划人员'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_buyer') || '采购人员'"
            >
              <dict-select
                v-model="form.listBuyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_choose_search_placeholder_buyer') || '请选择采购人员'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_create') || '创建人'"
            >
              <dict-select
                v-model="form.listCreateBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_choose_search_placeholder_create') || '请选择创建人'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_choose_search_label_createTime') || '创建时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_choose_search_placeholder_createTimeStart') ||
                        '创建时间开始'
                    "
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_choose_search_placeholder_createTimeEnd') ||
                        '创建时间结束'
                    "
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_modify') || '修改人'"
            >
              <dict-select
                v-model="form.listModifyBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_choose_search_placeholder_modify') || '请选择修改人'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_choose_search_label_modifyTime') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_choose_search_placeholder_modifyTimeStart') ||
                        '修改时间开始'
                    "
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_choose_search_placeholder_modifyTimeEnd') ||
                        '修改时间结束'
                    "
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_choose_search_label_isVc') || '是否VC产品'"
            >
              <el-checkbox-group v-model="form.listIsVc">
                <el-checkbox label="Y">
                  {{ $l('form_choose_search_label_isVc_Y') || '是' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('form_choose_search_label_isVc_N') || '否' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', listIsVc: ['Y', 'N'], listEvgSpuStatus: ['Y'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      categoryTree: [],
    }
  },
  mounted() {
    this.getTreeData()
    this.query()
  },
  methods: {
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi({ parentCode: 'ABSHome' })
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
